import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  basicDetails: {
    name: '',
    channel: '',
    packageName: '',
    packageCode: '',
    providerType: 'API',
    periodInMonths: '',
    benefitAggregateId: null
  }
};

export const ProviderSlice = createSlice({
  name: 'provider',
  initialState,
  reducers: {
    setBasicDetails: (state, action) => {
      state.basicDetails = action.payload;
    },
    setField: (state, action) => {
      const { field, value } = action.payload;
      state.basicDetails[field] = value;
    },
    reset: () => initialState,
  },
});

export const {
  setBasicDetails,
  setField,
  reset,
} = ProviderSlice.actions;

export default ProviderSlice.reducer;
